import dayjs from "./datetime"

export const isDev = process.env.NODE_ENV === "development"

export const isNode = process.release?.name === "node"

export const isTest = process.env.NODE_ENV === "test"

export const isServer = typeof window === "undefined"

export const ProductionHost = "team-tracker.ru"

const location = typeof globalThis !== "undefined" ? (globalThis as any).location : undefined

export const Host = location?.host || ProductionHost

export const Protocol = location?.protocol || "https:"

export const baseURL = `${Protocol}//${Host}`

export const adminLink = isDev ? `https://${ProductionHost}/admin` : "/admin"

export const version = process.env.VERSION

export const clientTimezone = dayjs.tz.guess()

if (isDev) {
  console.log("[ENV]", { baseURL, isDev, isTest, isNode, version })
}
